module.exports = __webpack_public_path__ + "img/container-storage.351a1ecc.svg";